import { render, staticRenderFns } from "./Disponibilidade2.vue?vue&type=template&id=1337fbb0&scoped=true&"
import script from "./Disponibilidade2.vue?vue&type=script&lang=js&"
export * from "./Disponibilidade2.vue?vue&type=script&lang=js&"
import style0 from "./Disponibilidade2.vue?vue&type=style&index=0&id=1337fbb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1337fbb0",
  null
  
)

export default component.exports